<template>
    <div>
        <buttonlist @help="help" @search="search" ref="SetBtn" @exps="exps" ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection" v-if="isbatch"></el-table-column>
            <el-table-column v-for="item in returnHeadArray"
                             :key="item.ColumnsField"
                             :prop="item.ColumnsField"
                             :label="item.ColumnsName"
            >
            </el-table-column>
        </el-table>
        <el-dialog v-dialogDrag :visible.sync="isVisiblePayMent" :title="$t('getapi[9328]')" width="40%">
            <div>
                <el-button type="primary" size="mini" @click="addPayMentCollect" >{{$t('getapi[6708]')}}
                </el-button>
                <el-button type="primary" size="mini" @click="batchDel">{{
                    $t('getapi[4097]') }}
                </el-button>
            </div>
            <el-table
                    :data="detailPayMentCollect"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="300"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="days" :label="$t('getapi[9327]')" width="100" align="right">
                    <template scope="scope" >
                        <el-input size="mini" v-model="scope.row.days" @change="getEndDate(scope)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="begindate" :label="$t('getapi[4042]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="enddate" :label="$t('getapi[3327]')"></el-table-column>
                 </el-table>
               <span slot="footer" class="dialog-footer">
				<el-button @click="isVisiblePayMent = false" size="mini">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirm()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name: '3_paymentcollectview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                returnHeadArray: [], // 物料主文件表头
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                detailPayMentCollect:[],
                isVisiblePayMent:false,
                isbatch:false,
                selectData:[],
                FilePath:'',
                scrollTop:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            // that.stmethod=1;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[9357]"),this.$t("getapi[5131]"));
            },
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('search');
                
                if (that.dataSet.length > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,export');
                } 
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            addPayMentCollect() {
                let that = this;
                for (let i=0;i< that.detailPayMentCollect.length;i++) {
                    if(parseInt(that.detailPayMentCollect[i].days)<=0){
                        return;
                    }
                }
                that.detailPayMentCollect = [
                    ...that.detailPayMentCollect,
                    {
                        days: 0,
                        begindate: '',
                        enddate: 0,
                    }
                ];
            },
            batchDel(){
                let that=this;
                for (let i = that.selectData.length - 1; i >= 0; i--) {
                    that.detailPayMentCollect.splice(that.selectData[i].index, 1);
                }
            },
            // 多选
            handleSelectionChange(val) {
                let that = this;
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i])
                }
            },
            getEndDate(data) {
                let that = this;
                if(that.detailPayMentCollect.length==1){
                    that.detailPayMentCollect[data.$index].begindate ='';
                    that.detailPayMentCollect[data.$index].enddate =that.$limits.dateChange(that.detailPayMentCollect[data.$index].days);
                }
                else{
                    that.detailPayMentCollect[data.$index].begindate =that.$limits.dateChangeBydate(0,that.detailPayMentCollect[data.$index-1].enddate);
                    that.detailPayMentCollect[data.$index].enddate =that.$limits.dateChangeBydate(that.detailPayMentCollect[data.$index].days,that.detailPayMentCollect[data.$index-1].enddate);
                }
            },
            search() {
                let that = this;
                that.isVisiblePayMent = true;
                if (that.detailPayMentCollect.length == 0) {
                    that.addPayMentCollect();
                }
            },
            confirm() {
                let that = this
                let parm = that.detailPayMentCollect;
                that.loading = true;
                that.$http.urlpost('/Finance/PayMent/PayMentCollectView', parm, function (res) {
                    if (res.Success == 1) {
                        that.isVisiblePayMent=false;
                        that.dataSet = res.DataContent.DataList;
                        that.returnHeadArray = res.DataContent.ColumnsList;
                        that.FilePath=res.DataContent.FilePath;
                        that.isbatch=true;
                        that.total = res.Totals;
                        that.authority();
                        that.loading = false;
                    }
                });
            },
            exps() {
                let that = this
                if(!that.$limits.fnIsEmpty(that.FilePath)){
                    let hrefurl = Common.Url + that.FilePath;
                    window.open(hrefurl);
                }
                
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
